<template>
  <div class="exchange-detail padding-nav">
    <el-button @click="goback" type="text" icon="el-icon-d-arrow-left" style="margin-bottom:0.16rem;">Go
      back</el-button>
    <div class="detail-title-1">Borrow details</div>
    <div class="common-card">
      <div style="display: flex;align-items: baseline;justify-content: space-between;">
        <div class="detail-title-2">
          Borrow No. {{ pageData.current && pageData.current.loanId }}
          <!-- 预警状态 -->
          <span style="margin-left:0.40rem;margin-right:0.32rem;">
            <span v-if="pageData.current && pageData.current.status == 2" style="color: #FF9800;font-size: 0.18rem;">
              <i style="font-size:0.24rem;margin-right:0.1rem;" class="iconfont trn-yujing status-icon is-yujing"
                el-tooltip effect="dark"
                content="The collateral Value is below the Low Collatoral Warning Threshold and needs to be replenished."
                placement="top" />
              Warned
            </span>
            <span v-else-if="pageData.current && pageData.current.status == 3" style="color: #D71817;font-size: 0.18rem;">
              <i style="font-size:0.24rem;margin-right:0.1rem;" class="iconfont trn-qingsuan status-icon is-qingsuan"
                el-tooltip effect="dark"
                content="The collateral value is below the Liquidation Threshold and has been liquidated."
                placement="top" />
              Liquidated
            </span>
          </span>

          <!-- 还款状态 -->

          <span style="display: flex;align-items: end;">
            <img :src="getRepaymentStatusImg(pageData)" alt="" style="width:0.24rem" />
            <!-- <img src="@/assets/image/loan/unrepaidIcon.png" alt="" style="width:0.24rem" v-if="isUnrepaid(pageData)" />
          <img src="@/assets/image/loan/partiallyRepaidIcon.png" alt="" style="width:0.24rem"
            v-if="isPartiallyRepaid(pageData)" /> -->
            <!-- <img v-if="isRepaid(pageData)" src="@/assets/image/loan/repaidIcon.png" alt="" style="width:0.2rem;" /> -->
            <span style="margin-left:0.1rem;font-size: 0.20rem;">{{
              getRepaymentStatusText(pageData)
            }}</span>
          </span>
        </div>

        <span
          style="color: #225BFC;font-weight: 500;font-size:0.16rem;cursor: pointer;margin-left: 0.2rem;display: flex;align-items: center;"
          @click="toExploder()">Details
          <img src="@/assets/image/profile/blue_right_arrow.png"
            style="width: 0.16rem;height: 0.16rem;margin-left: 0.04rem;" />
        </span>

      </div>

      <el-row>
        <el-col :xs="24" :sm="24" :md="8" :lg="8">
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">Borrow Date(UTC):</span>
            <span style="color: #fff;font-weight: 500;font-size:0.2rem;">{{
              moment.utc(pageData.original && pageData.original.startTime * 1000).format("YYYY-MM-DD HH:mm:ss") }}</span>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8">
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">Due Date(UTC):</span>
            <span style="color: #fff;font-weight: 500;font-size:0.2rem;">{{
              calculateDueDate(pageData.original && pageData.original.startTime) }}</span>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8">
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">Interest Rate:</span>
            <span style="color: #fff;font-weight: 500;font-size:0.2rem;">{{ InterestRate }}</span>
          </div>
        </el-col>
        <!-- <el-col :xs="24" :sm="24" :md="11" :lg="11">
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">Collateral:</span>
            <big-number :number="pageData.unitAmount" style="color: #fff;font-weight: 500;font-size:0.2rem;"/>
            <span class="unit" style="margin-bottom: -0.05rem;">UNIT</span>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="13" :lg="13">
          <div class="detail-item spaceLeft">
            <span class="detail-item-label">Pending :</span>
            <big-number :number="pageData.totalDebt" style="color: #fff;font-weight: 500;font-size:0.28rem;"/>
            <span class="unit" style="margin-bottom: -0.1rem;">TCash</span>
          </div>
        </el-col> -->
      </el-row>
    </div>

    <div class="second-card">
      <div style="flex: 0.9" class="common-card">
        <div class="detail-title-2">Initial Data</div>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label" style="font-size: 0.20rem;">Collateral:</span>
              <big-number :number="pageData.original && pageData.original.unitAmount"
                style="color: #fff;font-weight: 500;font-size:0.28rem;" />
              <span class="unit" style="margin-bottom: -0.05rem;">UNIT</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label" style="font-size: 0.20rem;">Borrow:</span>
              <big-number :number="pageData.original && (pageData.original.loanAmount - pageData.original.interest)"
                style="color: #fff;font-weight: 500;font-size:0.28rem;" />
              <span class="unit" style="margin-bottom: -0.05rem;">TCash</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">UNIT Price: $ {{ pageData.original && pageData.original.unitPrice ? (+pageData.original.unitPrice / 1e18).toFixed(2) : '0.00'
                }}</span>
              <span class="unit" style="margin-bottom: -0.05rem;">Value: $ {{ pageData.original && pageData.original.unitAmount && pageData.original.unitPrice ? (+pageData.original.unitAmount / 1e18 * +pageData.original.unitPrice / 1e18).toFixed(2) : '0.00' }}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft" style="align-items: baseline">
              <span class="detail-item-label">TCash Price: $ {{ pageData.original && pageData.original.loanPrice ? (+pageData.original.loanPrice / 1e18).toFixed(2) : '0.00'
                }}</span>
              <span class="unit" style="margin-bottom: -0.05rem;">Value: $ {{ pageData.original && pageData.original.loanAmount && pageData.original.loanPrice ? (+pageData.original.loanAmount / 1e18 * +pageData.original.loanPrice / 1e18).toFixed(2) : '0.00' }}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Risk Factors:</span>
              <span style="color: #929DAD;font-weight: 500;font-size:0.16rem;">{{ 
                isNaN(+pageData.original && pageData.original.CRF / 10000) ? '0.00' : (+pageData.original && pageData.original.CRF / 10000).toFixed(2) 
                }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="common-card"
        style="flex: 1.2;background: linear-gradient( 307deg, rgba(0, 37, 104, 0.6) 0%, rgba(6, 33, 79, 0.6) 100%);">
        <div class="detail-title-2">Current Data</div>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label" style="font-size: 0.20rem;">Collateral:</span>
              <big-number :number="pageData.current && pageData.current.unitAmount"
                style="color: #fff;font-weight: 500;font-size:0.28rem;" />
              <span class="unit" style="margin-bottom: -0.05rem;">UNIT</span>
              <span class="unit" style="font-size: 0.20rem;margin-bottom: -0.05rem;color: #DCE0E7;">
                $
                <big-number :number="unitValueInWei" style="font-size: 0.28rem;color: #DCE0E7;" />
              </span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label" style="font-size: 0.20rem;">Outstanding:</span>
              <big-number :number="pageData.current && pageData.current.loanAmount"
                style="color: #fff;font-weight: 500;font-size:0.28rem;" />
              <span class="unit" style="margin-bottom: -0.05rem;">TCash</span>
              <span class="unit" style="margin-bottom: -0.05rem;font-size: 0.20rem;color: #DCE0E7;">
                $
                <big-number :number="calculateTCashValueInWei()" style="font-size: 0.28rem;color: #DCE0E7;" />
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Risk Factors:</span>
              <span style="color: #929DAD;font-weight: 500;font-size:0.16rem;">{{ 
                isNaN(+pageData.current && pageData.current.CRF / 10000) ? '0.00' : (+pageData.current && pageData.current.CRF / 10000).toFixed(2)
                }}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Borrow:</span>
              <big-number :number="pageData.current && (pageData.current.loanAmount - pageData.current.interest)"
                style="color: #fff;font-weight: 500;font-size:0.2rem;" />
              <span class="unit" style="margin-bottom: -0.05rem;">TCash</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="display: flex;justify-content: space-between;align-items: baseline;">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Collateral Ratio:</span>
              <span
                :style="pageData.current && pageData.current.status == 3 ? 'color: #D71718;' : pageData.current && pageData.current.status == 2 ? 'color: #FF8A1B;' : 'color: #36E3C2;'"
                style="font-weight: 500;font-size:0.16rem;">
                {{ calculateCollateralRatio() }}%
              </span>
              <el-tooltip
                v-if="calculateCollateralRatio() > 0"
                :content="pageData.current && pageData.current.status == 3
                  ? 'Your collateral ratio has fallen below the liquidation threshold (50%) and has been liquidated.'
                  : 'Your collateral ratio has fallen below the early warning threshold (75%). Please add collateral promptly.'"
                placement="top">
                <img style="margin-left: 0.04rem;width: 0.16rem;height: 0.16rem;margin-right: 0.08rem;"
                  src="@/assets/icons/more.png" />
              </el-tooltip>
              <span v-if="pageData.current && pageData.current.status == 2"
                style="color: #225BFC;font-size: 0.16rem;margin-left:Add Collateral 0.08rem;cursor: pointer;"
                @click="toAddCollate()">Add Collateral</span>
              <div v-else-if="pageData.current && pageData.current.status == 3" style="display: flex;align-items: baseline;">
                <span style="color: #D71718;font-size: 0.16rem;">This borrow has been liquidated
                </span>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="detail-item spaceLeft">
              <span class="detail-item-label">Interest:</span>
              <big-number :number="pageData.current && pageData.current.interest" style="color: #fff;font-weight: 500;font-size:0.2rem;" />
              <span class="unit" style="margin-bottom: -0.05rem;">TCash</span>
              <span
                style="color: #225BFC;font-weight: 500;font-size:0.2rem;margin-bottom: -0.05rem;cursor: pointer;margin-left: 0.2rem;display: flex;align-items: center;"
                @click="goInterestRecord()">Details
                <img src="@/assets/image/profile/blue_right_arrow.png"
                  style="width: 0.16rem;height: 0.16rem;margin-left: 0.04rem;" />
              </span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>


    <div class="common-card">
      <div class="detail-title-2">Collateral Change Record</div>
      <el-table class="common-table" :data="tableList1" v-loading="loading">
        <el-table-column prop="date" label="Time" align="left">
          <template slot-scope="{ row }">
            {{ moment.utc(row.date).format("YYYY.MM.DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column prop="event" label="Type" align="left">
          <template slot-scope="{ row }">
            {{ row.event === 0 ? 'Borrow TCash' : row.event === 1 ? 'Return UNIT' : 'Add Collateral' }}
          </template>
        </el-table-column>
        <el-table-column prop="change" label="Balance change" align="right">
          <template slot-scope="{ row }">
            <big-number :number="row.change" />
            <span class="td-word-sm">UNIT</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="Total collateral" align="right">
          <template slot-scope="{ row }">
            <big-number :number="row.amount" />
            <span class="td-word-sm">UNIT</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="UNlT spot price" align="right">
          <template slot-scope="{ row }">
            <!-- $ {{ (+row.price / 1e18).toFixed(2) }} -->
            $ <big-number :number="row.price" />
          </template>
        </el-table-column>
        <el-table-column label="Total Value" align="right">
          <template slot-scope="{ row }">
            <!-- $ {{ (+row.price * +row.amount / 1e36) }} -->
            $ <big-number :number="(row.price / 1e18) * (row.amount)" />
          </template>
        </el-table-column>
        <el-table-column label="Starting collateral rate" align="right">
          <template slot-scope="{ row }">
            {{ row.LTV[0] }}%
          </template>
        </el-table-column>
        <el-table-column label="New collateral rate" align="right">
          <template slot-scope="{ row }">
            {{ row.LTV[1] }}%
          </template>
        </el-table-column>
      </el-table>
      <pagination :total.sync="queryParams1.total" :page.sync="queryParams1.page" :limit.sync="queryParams1.pageSize"
        @pagination="getCollateralChangeRecord()" />
    </div>
    <div class="common-card">
      <div class="detail-title-2">Repayment Record</div>
      <el-table class="common-table" :data="tableList2" v-loading="loading">
        <el-table-column prop="timestamp" label="Time" align="left">
          <template slot-scope="{ row }">
            {{ moment.utc(row.timestamp * 1000).format("YYYY.MM.DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="Type" align="left">
          <template slot-scope="{ row }">
            <!-- {{ returnedMap["status_" + row.operationStatus] }} -->
            Repayment
          </template>
        </el-table-column>
        <el-table-column prop="repayAmount" label="Repayment" align="right">
          <template slot-scope="{ row }">
            <!-- {{ row.operationStatus == 3 ? "-" : "+" }}  -->
            <big-number :number="row.repayAmount" />
            <span class="td-word-sm">TCash</span>
          </template>
        </el-table-column>
        <el-table-column prop="unitAmount" label="Collateral Released" align="right">
          <template slot-scope="{ row }">
            <big-number :number="row.unitAmount" />
            <span class="td-word-sm">UNIT</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total.sync="queryParams2.total" :page.sync="queryParams2.page" :limit.sync="queryParams2.pageSize"
        @pagination="getRepaymentRecord()" />
    </div>

    <!-- 利息记录弹窗 -->
    <el-dialog title="Interest Record" :visible.sync="interestDialogVisible" width="50%"
      :before-close="() => interestDialogVisible = false" class="interest-dialog" :center="true">
      <el-table class="common-table" :data="interestTableList" v-loading="loading">
        <el-table-column prop="date" label="Time（UTC）" align="left">
          <template style="color: #6B6B6B;" slot-scope="{ row }">
            <span style="color: #6B6B6B;">{{ moment.utc(row.createdAt).format("YYYY.MM.DD HH:mm:ss") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="interest" label="Interest Amount" align="right">
          <template style="color: #6B6B6B;" slot-scope="{ row }">
            <span style="color: #6B6B6B;">
              <big-number style="color: #6B6B6B;" :number="row.interest" />
              <span class="td-word-sm">TCash</span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total.sync="interestQueryParams.total" :page.sync="interestQueryParams.page"
        :limit.sync="interestQueryParams.pageSize" @pagination="getInterestRecord()" />
    </el-dialog>
    <addCollate ref="addCollate" @refresh="refresh" />
  </div>
</template>

<script>
import { loanDetail, getRepayList, getCollateralChangeRecordList, getInterestList } from "@/api/ustn/loan.js";
import {
  toSmallNum,
} from "@/utils/bigNumberTran.js";
import addCollate from "./addCollateDialog.vue";
export default {
  components: { addCollate },
  data() {
    return {
      contractTCashLoan: null,
      contractOracle: null,
      loading: false,
      pageData: {
        current: {
          interest: 0,
          loanPrice: 0,
          unitPrice: 0,
          unitAmount: 0,
          loanAmount: 0,
          CRF: 0
        },
        original: {
          loanAmount: 0,
          interest: 0,
          loanPrice: 0,
          unitAmount: 0,
          unitPrice: 0,
          CRF: 0
        }
      },
      queryParams1: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      queryParams2: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList1: [],
      tableList2: [],
      collateralMap: {
        "status_1": "Mortgage",
        "status_2": "Add collateral",
        "status_3": "Repayment"
      },
      returnedMap: {
        "status_1": "Loan",
        "status_3": "Repayment",
        "status_4": "Interest",
      },
      unitPrice: 0,
      TCASHPrice: 0,
      InterestRate: '0%',
      interestDialogVisible: false,
      interestTableList: [],
      interestQueryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tcashValueInWei: '0',
      unitValueInWei: '0',
    };
  },
  computed: {},
  methods: {
    toExploder() {
      window.open(`https://blockscout.testnet.treasurenet.io/tx/${this.pageData.current.blockHash}`, '_blank');
    },
    getRepaymentStatusImg(data) {
      if (this.isRepaid(data)) {
        return require('@/assets/image/loan/repaidIcon.png');
      } else if (this.isPartiallyRepaid(data)) {
        return require('@/assets/image/loan/partiallyRepaidIcon.png');
      } else {
        return require('@/assets/image/loan/unrepaidIcon.png');
      }
    },
    getRepaymentStatusText(data) {
      // 根据贷款金额比较判断状态
      if (this.isRepaid(data)) {
        return "Repaid";
      } else if (this.isPartiallyRepaid(data)) {
        return "Partially Repaid";
      } else {
        return "Unpaid";
      }
    },
    isRepaid(data) {
      // 完全还清，剩余贷款金额为0
      return Number(data.current && data.current.loanAmount) === 0;
    },
    isPartiallyRepaid(data) {
      // 部分还清，剩余贷款金额小于原始贷款金额但大于0
      return Number(data.current && data.current.loanAmount) > 0 && Number(data.current && data.current.loanAmount) < Number(data.original && data.original.loanAmount);
    },
    isUnrepaid(data) {
      console.log('isUnrepaid', data);
      // 未还款，剩余贷款金额等于原始贷款金额
      return Number(data.current && data.current.loanAmount) === Number(data.original && data.original.loanAmount);
    },
    calculateDueDate(startTime) {
      if (!startTime) return '-';
      // 计算一年后的到期日期
      console.log('startTime', startTime);
      // 将秒级时间戳转换为毫秒级
      const startDate = new Date(Number(startTime) * 1000);
      const dueDate = new Date(startDate);
      dueDate.setFullYear(startDate.getFullYear() + 1); // 准确增加一年
      return this.moment.utc(dueDate).format("YYYY.MM.DD");
    },
    async getLoanDetail() {
      const res = await loanDetail({
        loanId: this.$route.query.loanId,
      });
      // console.log('getLoanDetailres', res);
      this.pageData = res.result;

      // 计算TCash价值
      if (this.pageData.current && this.pageData.current.loanAmount && this.pageData.current.interest && this.pageData.current.loanPrice) {
        const loanAmount = new this.BigNumber(this.pageData.current.loanAmount);
        const interest = new this.BigNumber(this.pageData.current.interest);
        const tcashPrice = new this.BigNumber(this.pageData.current.loanPrice);
        console.log('loanAmount', loanAmount);
        console.log('interest', interest);
        console.log('tcashPrice', tcashPrice);
        this.tcashValueInWei = loanAmount.plus(interest).multipliedBy(tcashPrice).dividedBy(1e18).toString();
      }

      // 计算Unit价值
      if (this.pageData.current && this.pageData.current.unitAmount && this.pageData.current.unitPrice) {
        const unitAmount = new this.BigNumber(this.pageData.current.unitAmount);
        const unitPrice = new this.BigNumber(this.pageData.current.unitPrice);
        this.unitValueInWei = unitAmount.multipliedBy(unitPrice).dividedBy(1e18).toString();
      }
      // this.getCollateralChangeRecord();
      // this.getRepaymentRecord();
    },
    //getCollateralTopUpList
    async getCollateralTopUpList() {
      const res = await getCollateralChangeRecordList({
        loanId: this.$route.query.loanId,
      });
      console.log('getCollateralTopUpListres', res);
      this.tableList1 = res.result.list || [];
      this.queryParams1.total = res.result.total || 0;
    },


    async getRepaymentRecord() {
      this.loading = true;
      try {
        console.log('getRepaymentRecord', this.$route.query.loanId);
        const res = await getRepayList({
          loanId: this.$route.query.loanId,
          borrower: this.$store.getters.metaMaskObj.account,
          page: this.queryParams2.page,
          pageSize: this.queryParams2.pageSize
        });
        this.tableList2 = res.result.list || [];
        this.queryParams2.total = res.result.total || 0;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    toAddCollate() {
      this.$refs.addCollate.open({
        row: {
          ...this.pageData.current,
          LoanPledgeRateWarningValue: this.pageData.current.CRF
        }
      });
    },
    async getPrice() {
      await this.getUnitPrice();
      await this.getTCashPrice();
    },
    showPledge(data) {
      let unit = new this.BigNumber(data.unitAmount).multipliedBy(data.unitPrice);
      let loan = new this.BigNumber(data.loanAmount).multipliedBy(data.loanPrice);
      let res = unit.dividedBy(loan).multipliedBy(100).toNumber();
      return Math.round(res * 100) / 100;
      // if(+data[type] != 0){
      //   return data[type]/100;
      // }else{
      //   if(+data.totalDebt == 0){
      //     if(beforeItem){
      //       return this.showPledge(beforeItem, "pledgeRateBefore");
      //     }
      //     return 0;
      //   }
      //   let unit = new this.BigNumber(data.unitAmount).multipliedBy(data.unitPrice);
      //   let loan = new this.BigNumber(data.loanAmount).multipliedBy(data.loanPrice);
      //   let res = unit.dividedBy(loan).multipliedBy(100).toNumber();
      //   return Math.round(res * 100) / 100;
      // }
    },
    goback() {
      this.$router.push({
        path: "/TCashFinance/lending",
        query: {
          detail: 1
        }
      });
    },
    async refresh() {
      this.contractOracle = this.$store.getters.contractMap["contractOracle"].contract;
      //contractParameterInfo
      this.contractParameterInfo = this.$store.getters.contractMap["contractParameterInfo"].contract;
      // 获取平台配置信息
      try {
        const platformConfig = await this.contractParameterInfo.methods.getPlatformConfig("TCASHDIR").call({
          from: this.$store.getters.metaMaskObj.account
        });
        // console.log('TCASHDIR平台配置:', platformConfig);
        this.InterestRate = (+platformConfig / 100).toFixed(2) + '%';
      } catch (error) {
        console.error('获取TCASHDIR平台配置失败:', error);
      }
      await this.getLoanDetail();
      await this.getPrice();

      // 确保TCash价值计算正确
      if (this.pageData.current && this.pageData.current.loanAmount && this.pageData.current.interest && this.pageData.current.loanPrice) {
        const loanAmount = new this.BigNumber(this.pageData.current.loanAmount);
        const interest = new this.BigNumber(this.pageData.current.interest);
        const tcashPrice = new this.BigNumber(this.pageData.current.loanPrice);
        this.tcashValueInWei = loanAmount.plus(interest).multipliedBy(tcashPrice).dividedBy(1e18).toString();
      }

      // 确保Unit价值计算正确
      if (this.pageData.current && this.pageData.current.unitAmount && this.pageData.current.unitPrice) {
        const unitAmount = new this.BigNumber(this.pageData.current.unitAmount);
        const unitPrice = new this.BigNumber(this.pageData.current.unitPrice);
        this.unitValueInWei = unitAmount.multipliedBy(unitPrice).dividedBy(1e18).toString();
      }

      this.getRepaymentRecord();
      this.getCollateralTopUpList();
    },
    calculateCollateralRatio() {
      // 计算当前抵押率
      if (!this.pageData.current) {
        return 0;
      }

      // 计算UNIT抵押物总价值
      const unitAmount = new this.BigNumber(this.pageData.current.unitAmount || 0);
      const unitPrice = new this.BigNumber(this.pageData.current.unitPrice || 0);
      const unitTotalValue = unitAmount.multipliedBy(unitPrice).dividedBy(1e18);

      // 计算TCash借款总价值
      const tcashAmount = new this.BigNumber(this.pageData.current.loanAmount || 0);
      const tcashPrice = new this.BigNumber(this.pageData.current.loanPrice || 0);
      const tcashTotalValue = tcashAmount.multipliedBy(tcashPrice).dividedBy(1e18);

      // 如果借款价值为0，则避免除以0的错误
      if (tcashTotalValue.isEqualTo(0)) {
        return 0;
      }

      // 计算抵押率并返回百分比值，保留2位小数
      return unitTotalValue.dividedBy(tcashTotalValue).multipliedBy(100).toFixed(2);
    },
    calculateUnitValue() {
      // 直接返回已计算好的值
      return this.unitValueInWei;
    },
    calculateOutstanding() {
      // 计算总欠款 = 贷款金额 + 利息
      if (!this.pageData.current || !this.pageData.current.loanAmount || !this.pageData.current.interest) {
        return 0;
      }
      const loanAmount = new this.BigNumber(this.pageData.current.loanAmount);
      const interest = new this.BigNumber(this.pageData.current.interest);
      return loanAmount.plus(interest).toString();
    },
    calculateTCashValueInWei() {
      // 直接返回已计算好的值
      return this.tcashValueInWei;
    },
    async getUnitPrice() {
      try {
        let Oracleres = await this.contractOracle.methods.getPriceData("UNIT").call({
          from: this.$store.getters.metaMaskObj.account
        });
        this.unitPrice = (Oracleres.price / 10000).toFixed(2);
      } catch (e) {
        console.log(e);
      }
    },
    async getTCashPrice() {
      try {
        let Oracleres = await this.contractOracle.methods.getPriceData("TCASH").call({
          from: this.$store.getters.metaMaskObj.account
        });
        this.TCASHPrice = (Oracleres.price / 10000).toFixed(2);
      } catch (e) {
        console.log(e);
      }
    },
    async goInterestRecord() {
      this.interestDialogVisible = true;
      await this.getInterestRecord();
    },
    async getInterestRecord() {
      this.loading = true;
      try {
        const res = await getInterestList({
          loanId: this.$route.query.loanId,
          page: this.interestQueryParams.page,
          pageSize: this.interestQueryParams.pageSize
        });
        console.log('getInterestRecord', res);
        this.interestTableList = res.result.list || [];
        this.interestQueryParams.total = res.result.total || 0;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.pageData = {
      ...this.$route.query
    }
    this.refresh();
  }
};
</script>
<style scoped lang="scss">
.exchange-detail {
  width: 90%;
  margin: 0 auto;
}

.common-card {
  border-radius: 0.08rem;
  //background: #fff;
  box-shadow: 0 0.12rem 0.28rem 0 rgba(6, 16, 32, 0.05);
  margin-bottom: 0.2rem;
}

.detail-title-1 {
  margin-bottom: 0.28rem;
}

.detail-title-2 {
  color: #fff;
  font-weight: bold;
  font-size: 0.26rem;
  margin-bottom: 0.26rem;
  display: flex;
  align-items: center;
  // letter-spacing: 0.05rem;
  word-spacing: 0.03rem;
  font-family: HurmeGeometricSans2-Bold, HurmeGeometricSans2;
}

.unit {
  font-size: 0.16rem;
  font-weight: 400;
  color: #929dad;
  margin-left: 0.04rem;
}

.common-table {
  >>>.el-loading-mask {
    background-color: rgba(0, 0, 0, .6);
  }

  >>>.el-loading-spinner .path {
    stroke: #2675f1;
  }
}

.detail-item-label {
  color: rgba(255, 255, 255, .7);
  font-size: 0.16rem;
}

.second-card {
  display: flex;
  gap: 0.2rem;
  margin-bottom: 0.2rem;

  .common-card {
    flex: 1;
    background: linear-gradient(307deg, rgba(3, 28, 73, 0.6) 0%, rgba(1, 13, 35, 0.6) 100%);
    border-radius: 0.24rem;
    // border: 0.01rem solid;
    // opacity: 0.6;
    // border-image: linear-gradient(221deg, rgba(255, 255, 255, 0.39), rgba(255, 255, 255, 0.01)) 1 1;
    backdrop-filter: blur(0.04411764705882352rem);
  }
}

.interest-dialog {
  // background: linear-gradient(307deg, rgba(3, 28, 73, 0.6) 0%, rgba(1, 13, 35, 0.6) 100%);
  // border-radius: 0.6rem;
  // backdrop-filter: blur(0.04411764705882352rem);

  >>>.el-dialog {
    border-radius: 0.4rem;
    overflow: hidden;
    margin-top: 20vh !important;
    /* 调整对话框的垂直位置 */
    max-height: 45vh !important;
  }

  >>>.el-dialog__title {
    color: #1F1F1F;
  }

  >>>.el-dialog__header {
    border-bottom: 0.01rem solid rgba(255, 255, 255, 0.1);
    padding: 0.2rem 0.24rem;
  }

  >>>.el-dialog__body {
    padding: 0rem 0.24rem 0.24rem 0.24rem;
  }

  >>>.el-pager li:not(.disabled).active {
    // background-color: #225BFC;
    color: #6B6B6B;
    font-weight: bold;
  }
}

// 添加分页组件样式
>>>.el-pagination {
  text-align: right;
  // margin-top: 16px;

  .btn-prev,
  .btn-next,
  .el-pager li {
    background-color: transparent;
    color: #909399;
  }

  .el-pager li.active {
    background-color: #225BFC;
    color: #6B6B6B;
    font-weight: bold;
  }

  // 确保数字在按钮内可见
  .el-pager li {
    min-width: 0.3rem;
    border-radius: 0.04rem;
    color: #6B6B6B;

    &.active {
      box-shadow: 0 0.02rem 0.08rem rgba(34, 91, 252, 0.4);
    }
  }

  .el-pagination__total,
  .el-pagination__jump {
    color: #909399;
  }
}
</style>
